import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomFormsModule } from 'ng2-validation';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { DatepickerModule, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ToasterModule, ToasterService } from 'angular2-toaster';

import { FlotDirective } from './directives/flot/flot.directive';
import { SparklineDirective } from './directives/sparkline/sparkline.directive';
import { EasypiechartDirective } from './directives/easypiechart/easypiechart.directive';
import { ColorsService } from './colors/colors.service';
import { CheckallDirective } from './directives/checkall/checkall.directive';
import { VectormapDirective } from './directives/vectormap/vectormap.directive';
import { NowDirective } from './directives/now/now.directive';
import { ScrollableDirective } from './directives/scrollable/scrollable.directive';
import { JqcloudDirective } from './directives/jqcloud/jqcloud.directive';

import { NgxMaskModule } from 'ngx-mask';
import { MobilePipe } from './directives/mobile/mobile';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { NgxErrorsModule } from '@ultimate/ngxerrors';
import { TotalByDirective } from './directives/totalFor/totalFor.directive';
import { HtmlPipe } from './directives/html/html.pipe';
import { AppMultiplePeriodSelectorComponent } from './components/multiple-period-selector/multiple-period-selector.component';
import { AppPeriodSelectorComponent } from './components/period-selector/period-selector.component';
import { AppDropdownComponent } from './components/dropdown/dropdown.component';
import { AppReportFormComponent } from './components/report-form/report-form.component';
import { AppNewVacationFormComponent } from './components/add-vacation-form/new-vacation-form.component';
import { LocalStorageModule } from 'angular-2-local-storage';
import { CookieService } from 'ngx-cookie-service';
import { AuthGuardService } from '../services/AuthGuardService';
import { AuthService } from '../services/AuthService';
import { RoleGuardService } from '../services/RoleGuardService';
import { ReportingService } from '../services/ReportingService';
import { UserTokenService } from '../services/UserTokenService';
import { ProfileService } from '../services/ProfileService';
import { AppUserDocumentsComponent } from './components/user-documents/user-documents.component';
import { EventsService } from '../services/EventsService';
import { FilterByPipe } from './directives/filter-ng-for/filterNgFor.pipe';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        ToasterModule.forRoot(),
        AccordionModule.forRoot(),
        AlertModule.forRoot(),
        ButtonsModule.forRoot(),
        CarouselModule.forRoot(),
        CollapseModule.forRoot(),
        DatepickerModule.forRoot(),
        BsDatepickerModule.forRoot(),
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        PaginationModule.forRoot(),
        ProgressbarModule.forRoot(),
        RatingModule.forRoot(),
        TabsModule.forRoot(),
        TimepickerModule.forRoot(),
        TooltipModule.forRoot(),
        TypeaheadModule.forRoot(),
        NgxMaskModule.forRoot(),
        SweetAlert2Module.forRoot({
            buttonsStyling: false,
            customClass: 'modal-content',
            confirmButtonClass: 'btn btn-primary',
            cancelButtonClass: 'btn'
        }),
        NgxErrorsModule,
        CustomFormsModule,
        LocalStorageModule.withConfig({
            prefix: 'devrecords',
            storageType: 'localStorage'
        })
    ],
    providers: [
        ColorsService,
        ToasterService,
        CookieService,
        AuthGuardService,
        RoleGuardService,
        AuthService,
        ReportingService,
        UserTokenService,
        ProfileService,
        EventsService
    ],
    declarations: [
        FlotDirective,
        SparklineDirective,
        EasypiechartDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        JqcloudDirective,
        MobilePipe,
        HtmlPipe,
        AppDropdownComponent,
        AppPeriodSelectorComponent,
        AppMultiplePeriodSelectorComponent,
        AppReportFormComponent,
        TotalByDirective,
        AppNewVacationFormComponent,
        AppUserDocumentsComponent,
        FilterByPipe
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        RouterModule,
        AccordionModule,
        AlertModule,
        ButtonsModule,
        CarouselModule,
        CollapseModule,
        DatepickerModule,
        BsDropdownModule,
        BsDatepickerModule,
        ModalModule,
        PaginationModule,
        ProgressbarModule,
        RatingModule,
        TabsModule,
        TimepickerModule,
        TooltipModule,
        TypeaheadModule,
        FlotDirective,
        SparklineDirective,
        EasypiechartDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        JqcloudDirective,
        MobilePipe,
        HtmlPipe,
        AppDropdownComponent,
        NgxMaskModule,
        ToasterModule,
        SweetAlert2Module,
        TotalByDirective,
        AppPeriodSelectorComponent,
        AppReportFormComponent,
        AppMultiplePeriodSelectorComponent,
        AppNewVacationFormComponent,
        AppUserDocumentsComponent,
        FilterByPipe
    ]
})

export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule
        };
    }
}
